<template>
  <div class="card mgt-20px">
    <header class="header-card">
      <p>
        {{ $t('detailCommande.generalTitle.achat') }}
      </p>
    </header>
    <div class="card-content">
      <div class="level">
        <div class="level-left">
          <div class="columns">
            <form @submit.prevent="recherche()"
              class="column is-6">
              <b-input :placeholder="$t('general.button.search')"
                type="search"
                icon="magnify"
                v-model="critereRecherche.auto">
              </b-input>
            </form>
            <div class="column is-narrow">
              <button class="button" @click='changeValueShowFiltreAndLockMenu()'>
                <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
                <span class="is-size-7">{{$t('listeCommandes.actions.filtre')}}
                  <label class="has-text-weight-bold"
                    :class="nombreCritere > 0 ? '' : 'is-invisible'">
                    ({{ nombreCritere }})
                  </label>
                </span>
              </button>
              <span @click="reinitialiser()"
                class="info-circle-right is-pulled-right is-cursor-pointer">
                <b-icon icon="close-circle" type="is-danger"></b-icon>
              </span>
            </div>
          </div>
        </div>
        <div class="columns is-6 level-right">
          <div class="column is-narrow">
            <button
              class="button is-addOrEdit is-pulled-right"
              @click="checkPermissions(permCommandes.maj)
                ? $router.push({ name: 'm.achat.commandes-creation',
                  params: { referenceExterne: $route.params.id } })
                : showPopUp()"
              :class="{ 'button-access-no-permission' : !checkPermissions(permCommandes.maj) }">
              {{ $t('detailCommande.commandeAchat.addCommande') }}
            </button>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column is-12">
          <v-server-table
            url=""
            :columns="columns"
            :options="options"
            :ref="referenceTable"
            @loaded="finLoading"
            @loading="debutLoading">
            <template #afterTable>
              <table-items-in-view
                @input="$refs[referenceTable].setLimit($event)"/>
            </template>
            <template #code="{ row }">
              <router-link-blank
                :to="{ name: 'c.achat.commandes', params: { id: row.id } }"
                :message="row.code">
              </router-link-blank>
            </template>
            <template #dateDevisCommande="{ row }">
              {{ func.formatDate(row.dateDevisCommande) }}
            </template>
            <template #listeIntervenants="{ row }">
              {{ row.listeIntervenants }}
            </template>
            <template #produitsLibelle="{ row }">
              {{ row.produitsLibelle }}
            </template>
            <template #etat="{ row }">
              {{ getEtatLibelle(row.etat) }}
            </template>
            <template #montantHt="{ row }">
              <div class="is-pulled-right">
                {{ func.formatDevise(row.montantHt) }}
              </div>
            </template>
            <template #editer="{ row }">
              <btn-action-icon
                :tooltip-label="$t('general.button.edition')"
                :permission="permCommandes.editer"
                @is-click="editionAction({
                  format: constantes.pdf,
                  typeDonnee: constantes.typeEditionCommande,
                }, row)"
                icon="file-pdf-box">
              </btn-action-icon>
            </template>
            <template #envoiMail>
              <btn-action-icon
                :tooltip-label="$t('general.button.send')"
                :permission="permCommandes.lecture"
                @is-click="inProgress()"
                icon-type="is-default"
                icon="email-plus">
              </btn-action-icon>
            </template>
            <template #modifier="{ row }">
              <btn-action-icon
                :tooltip-label="$t('general.button.edit')"
                :permission="permCommandes.maj"
                @is-click="$router.push({ name: 'm.achat.commandes', params: { id: row.id } })"
                icon-type="is-success"
                icon="pencil-box-outline">
              </btn-action-icon>
            </template>
            <template #supprimer="{ row }">
              <btn-action-icon
                :tooltip-label="$t('general.button.delete')"
                :permission="permCommandes.supprimer"
                :disabled="getDisabledDeleted(row)"
                @is-click="openPopUpSuppression(row.id)"
                icon-type="is-danger"
                icon="delete-forever">
              </btn-action-icon>
            </template>
            <template #appendBody>
              <table-footer-totaux
                ref="tableTotaux"
                :columns="columns"
                :target="['montantHt']"
                :items="commandes">
              </table-footer-totaux>
            </template>
          </v-server-table>
        </div>
      </div>
    </div>
    <transition name="custom-classes-transition"
      enter-active-class="animate__animated animate__slideInRight"
      leave-active-class="animate__animated animate__slideOutRight" :duration="10">
      <div class="componentBrief" v-show="showFiltre === true">
        <filtre-liste-commande
          ref="filtreListeCommande"
          :nameStore="nameStore"
          @toggleFiltre="changeValueShowFiltreAndLockMenu()"
          @recherche="makeRechercheFilter()"/>
      </div>
    </transition>
    <b-modal v-model="popUpSuppression" has-modal-card class="modal">
      <pop-up-prevention
        :messHeader="$t('detailCommandeAchatFournisseur.suppressionTitle')"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        :isErrorPopup="isErrorPopup"
        :messagesPopup="messagesPopup"
        @no="popUpSuppression = false"
        @yes="deleteCommande()"/>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { remove } from '@/api/commandeAchat';
import edition from '@/api/edition';
import TableItemsInView from '@/components/general/TableItemsInView';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import { REFERENCE_TABLE_COMMANDE_CMDE_ACHAT } from '@/configuration/general/referenceTableConf';
import FiltreListeCommande from '@/components/commande/detail/commandeAchat/filtreListeCommandeAchat';
import checkPeriodeAndFormat from '@/services/dcf/checkPeriodeAndFormat';
import tagInputToArray from '@/services/general/filters/tagInputToArray';
import formatDate from '@/services/general/formatDate';
import RouterLinkBlank from '@/components/general/routerLinkBlank';
import {
  COMMANDE_ACHAT_FOURNISSEUR_ETAT,
  ETAT_SANSSUITE,
  ETAT_ENREGISTRE,
} from '@/configuration/devisConf';
import BtnActionIcon from '@/components/general/btnActionIcon';
import inProgress from '@/services/general/inProgress';
import { formatDevise } from '@/services/general/filters/formatDevise';
import { COMMANDES } from '@/configuration/achat/permissionsConf';
import tableFooterTotaux from '@/components/general/tableFooterTotaux';
import popUpPrevention from '@/components/general/popUpPrevention';
import validationCommandeAchat from '@/services/achat/commandes/validationCommandeAchat';
import messageSucces from '@/services/general/messageSucces';
import { TYPE_PDF } from '@/configuration/edition/editionConf';
import { TYPE_EDITION_CMD } from '@/configuration/achat/commandeAchat/commandeAchatConf';
import messageErreur from '@/services/general/messageErreur';
import * as devisConf from '@/configuration/devisConf';

const Societe = createNamespacedHelpers('societe');
const Permissions = createNamespacedHelpers('permissions');

export default {
  name: 'LCommandeAchat',
  props: {
    nameStore: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      referenceTable: REFERENCE_TABLE_COMMANDE_CMDE_ACHAT,
      showFiltre: false,
      func: {
        formatDate,
        formatDevise,
      },
      permCommandes: COMMANDES,
      constantes: {
        pdf: TYPE_PDF,
        typeEditionCommande: TYPE_EDITION_CMD,
      },
      popUpSuppression: false,
      isErrorPopup: false,
      messagesPopup: [],
      idCommandeToDelete: null,
    };
  },
  components: {
    TableItemsInView,
    FiltreListeCommande,
    RouterLinkBlank,
    BtnActionIcon,
    tableFooterTotaux,
    popUpPrevention,
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    commandes() {
      return this.$store.getters[`${this.nameStore}/commandes`];
    },
    totalCommandes() {
      return this.$store.getters[`${this.nameStore}/totalCommandes`];
    },
    critereRecherche: {
      get() {
        return this.$store.getters[`${this.nameStore}/criteresRecherche`];
      },
      set(value) {
        this.$store.commit(`${this.nameStore}/SET_CRITERE_RECHERCHE`, value);
      },
    },
    nombreCritere() {
      const banCritere = ['auto', 'dates', 'referenceExterne', 'societeId',
        'typeReferenceExterne', 'module', 'sousType'];
      let nbCritere = calculNombreCritere(this.critereRecherche, banCritere);
      if (this.critereRecherche.dates.dateDebut || this.critereRecherche.dates.dateFin) {
        nbCritere += 1;
      }
      return nbCritere > 9 ? '+9' : nbCritere;
    },
    columnsData() {
      return [
        { name: 'code', sortable: true },
        { name: 'dateDevisCommande', sortable: true },
        { name: 'listeIntervenants', sortable: false },
        { name: 'produitsLibelle', sortable: false },
        { name: 'etat', sortable: true },
        { name: 'montantHt', sortable: true },
        { name: 'editer', noTranslate: true },
        { name: 'envoiMail', noTranslate: true },
        { name: 'modifier', noTranslate: true },
        { name: 'supprimer', noTranslate: true },
      ];
    },
    columns() {
      return this.columnsData.map((column) => column.name);
    },
    options() {
      const headings = this.columnsData.reduce((acc, val) => {
        acc[val.name] = !val.noTranslate ? this.$t(`detailCommande.commandeAchat.table.${val.name}`) : '';
        return acc;
      }, {});
      return {
        sortIcon: SORT_ICON,
        headings,
        filterable: false,
        sortable: this.columnsData.filter((c) => c.sortable).map((c) => c.name),
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: TEXTS,
        columnsClasses: {
          listeIntervenants: 'ellipsis colonneListeIntervenants',
          produitsLibelle: 'ellipsis colonneListeIntervenants',
        },
        requestFunction: ((data) => {
          if (!data.query) data.query = cloneDeep(this.critereRecherche);
          checkPeriodeAndFormat(data.query, 'dates');
          data.query.tiersId = tagInputToArray(this.critereRecherche.tiersId, 'id');
          data.query.produitsIds = tagInputToArray(this.critereRecherche.produitsIds, 'id');
          data.query.societeId = this.societeActiveId;
          data.query.referenceExterne = this.$route.params.id;
          if (data.query.etat.length === 0) {
            data.query.etat = [
              devisConf.ETAT_ENREGISTRE,
              devisConf.ETAT_RECEPTIONNEE,
              devisConf.ETAT_FACTURE,
              devisConf.ETAT_RECEPTIONNEE_PARTIELLEMENT,
              devisConf.ETAT_FACTURE_PARTIELLEMENT,
            ];
          }
          return this.actionsLoadCommandesAchat(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.commandes,
            count: this.totalCommandes,
          };
        }),
      };
    },
  },
  methods: {
    actionsLoadCommandesAchat(data) {
      return this.$store.dispatch(`${this.nameStore}/loadCommandesAchat`, data);
    },
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    async changeValueShowFiltreAndLockMenu() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreListeCommande.initializeFiltre();
    },
    async reinitialiser() {
      await this.$refs.filtreListeCommande.initializeFiltre();
      this.$refs.filtreListeCommande.viderCritere();
      this.$refs.filtreListeCommande.appliquerCritere();
      this.showFiltre = false;
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.changeValueShowFiltreAndLockMenu();
      this.recherche();
    },
    getEtatLibelle(etat) {
      const find = COMMANDE_ACHAT_FOURNISSEUR_ETAT.find((el) => el.code === etat);
      return find ? this.$t(find.libelle) : '';
    },
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    openPopUpSuppression(id) {
      this.idCommandeToDelete = id;
      this.isErrorPopup = false;
      this.messagesPopup = [];
      this.popUpSuppression = true;
    },
    getDisabledDeleted(row) {
      return row.etat !== ETAT_ENREGISTRE
        && row.etat !== ETAT_SANSSUITE;
    },
    async deleteCommande() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await remove(this.idCommandeToDelete);
        this.popUpSuppression = false;
        this.idCommandeToDelete = null;
        messageSucces(this.$t('detailCommandeAchatFournisseur.suppressionMessageSuccess'));
        this.recherche();
      } catch (e) {
        this.isErrorPopup = true;
        if (e.response?.data?.error) {
          validationCommandeAchat(e.response, this.messagesPopup);
        } else messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
    async editionAction(donnees, row) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const response = await edition({
          ids: [row.id],
          extension: donnees.format,
          typeDonnee: donnees.typeDonnee,
          typeEdition: donnees.typeEdition ? donnees.typeEdition : '',
          parametresAdditionnels: {
            ...(donnees.parametresAdditionnels ?? {}),
            societeId: row.societeId,
          },
        });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
      } catch (e) {
        messageErreur(this.$i18n);
        throw (e);
      } finally {
        loadingComponent.close();
      }
    },
  },
};
</script>
